// ============================================================
// GESTION DE LA VIDÉO
// ============================================================
(function() {
    const video = document.getElementById('hero-video');
    const videoFallback = document.querySelector('.hero-video-fallback');
    // ✅ OPTIMISÉ : Utilise matchMedia au lieu de window.innerWidth
    const isMobile = window.matchMedia('(max-width: 768px)').matches;
    const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
    const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    const videoDesktop = 'https://cdn.shopify.com/videos/c/o/v/da8175987a54422da5a4403001572b2b.mp4';
    const videoMobile = 'https://cdn.shopify.com/videos/c/o/v/5d36530cd09843dea31e2d18849b137c.mp4';
    
    // Afficher le fallback temporairement
    videoFallback.style.opacity = '1';
    
    function loadVideo() {
        const videoSrc = isMobile ? videoMobile : videoDesktop;
        
        // Si la source est déjà la bonne, ne pas recharger
        if (video.src !== videoSrc) {
            video.src = videoSrc;
            video.load();
        }
        
        video.addEventListener('loadeddata', function handleLoadedData() {
            // Cacher le fallback une fois la vidéo prête
            videoFallback.style.opacity = '0';
            
            const playPromise = video.play();
            if (playPromise !== undefined) {
                playPromise.then(() => {
                    console.log('✅ Vidéo lancée avec succès');
                }).catch(error => {
                    console.log('⚠️ Autoplay bloqué, tentative de relance...');
                    // Garder le fallback visible si autoplay échoue
                    videoFallback.style.opacity = '1';
                    
                    if (isMobile) {
                        const startEvents = ['touchstart', 'touchend', 'click', 'scroll'];
                        function tryPlayOnInteraction() {
                            video.play().then(() => {
                                console.log('✅ Vidéo lancée après interaction mobile');
                                videoFallback.style.opacity = '0';
                                startEvents.forEach(evt => {
                                    document.removeEventListener(evt, tryPlayOnInteraction);
                                });
                            }).catch(e => console.log('Nouvelle tentative nécessaire:', e));
                        }
                        startEvents.forEach(evt => {
                            document.addEventListener(evt, tryPlayOnInteraction, { once: true });
                        });
                    }
                });
            }
        }, { once: true });
        
        // Timeout de sécurité : si la vidéo ne charge pas en 3 secondes, garder le fallback
        setTimeout(() => {
            if (video.readyState < 2) {
                console.log('⚠️ Vidéo lente à charger, affichage du fallback');
                videoFallback.style.opacity = '1';
            }
        }, 3000);
    }
    
    loadVideo();
    
    if (isMobile) {
        document.addEventListener('visibilitychange', function() {
            if (!document.hidden && video.paused) {
                video.play().catch(e => console.log('Relance vidéo après visibilité (mobile):', e));
            }
        });
        
        video.addEventListener('pause', function() {
            if (!video.ended && !document.hidden) {
                setTimeout(() => {
                    video.play().catch(e => console.log('Tentative de relance (mobile):', e));
                }, 100);
            }
        });
        
        window.addEventListener('orientationchange', function() {
            setTimeout(() => {
                video.play().catch(e => console.log('Relance après rotation (mobile):', e));
            }, 500);
        });
        
        if (isIOS) {
            setTimeout(() => {
                if (video.paused) {
                    video.play().catch(e => console.log('Tentative iOS:', e));
                }
            }, 1000);
            
            let scrollTimeout;
            window.addEventListener('scroll', function() {
                clearTimeout(scrollTimeout);
                scrollTimeout = setTimeout(() => {
                    if (video.paused && !document.hidden) {
                        video.play().catch(e => console.log('Relance iOS après scroll:', e));
                    }
                }, 150);
            }, { passive: true });
        }
    }
})();

// ============================================================
// FONCTION DE SCROLL FLUIDE (OPTIMISÉE MOBILE + DESKTOP)
// ============================================================
function smoothScrollTo(target) {
    if (!target) {
        console.warn('⚠️ Pas de cible pour le scroll');
        return;
    }
    
    console.log('📍 Scroll vers:', target.tagName, target.id || target.className);
    
    // Méthode 1 : scrollIntoView (meilleure compatibilité mobile)
    if ('scrollBehavior' in document.documentElement.style) {
        target.scrollIntoView({ 
            behavior: 'smooth', 
            block: 'start',
            inline: 'nearest'
        });
        console.log('✅ Scroll avec scrollIntoView');
        return;
    }
    
    // ✅ OPTIMISÉ : Méthode 2 sans getBoundingClientRect
    const startPosition = window.pageYOffset || document.documentElement.scrollTop;
    // Utilise offsetTop au lieu de getBoundingClientRect
    const targetPosition = target.offsetTop;
    const distance = targetPosition - startPosition;
    const duration = 1200;
    let start = null;
    
    function smoothScroll(currentTime) {
        if (start === null) start = currentTime;
        const timeElapsed = currentTime - start;
        const progress = Math.min(timeElapsed / duration, 1);
        
        // Easing function (ease-in-out)
        const ease = progress < 0.5 
            ? 4 * progress * progress * progress 
            : 1 - Math.pow(-2 * progress + 2, 3) / 2;
        
        window.scrollTo(0, startPosition + distance * ease);
        
        if (timeElapsed < duration) {
            requestAnimationFrame(smoothScroll);
        } else {
            console.log('✅ Scroll terminé');
        }
    }
    
    requestAnimationFrame(smoothScroll);
    console.log('✅ Scroll avec animation manuelle');
}

// ============================================================
// LIENS DE REDIRECTION DYNAMIQUES - OPTIMISÉS ✅
// ============================================================

// ✅ OPTIMISÉ : Fonction simplifiée sans multiples accès à offsetHeight/offsetWidth
function findTargetSection() {
    const heroSection = document.querySelector('.hero-section');
    let target = null;
    
    console.log('🔍 Recherche de la section cible...');
    
    // Option 1 : ID Shopify spécifique
    target = document.querySelector('#shopify-section-template--26535462601081__custom_liquid_aEhnDR');
    if (target) {
        console.log('✅ Trouvé via ID Shopify');
        return target;
    }
    
    // Option 2 : Première section Shopify après le hero
    const shopifySections = document.querySelectorAll('[id^="shopify-section-"]');
    if (shopifySections.length > 0) {
        for (let section of shopifySections) {
            if (heroSection && section !== heroSection.closest('[id^="shopify-section-"]')) {
                // ✅ OPTIMISÉ : Vérifie l'existence d'enfants au lieu d'offsetHeight
                if (section.children.length > 0) {
                    target = section;
                    console.log('✅ Trouvé via sections Shopify:', section.id);
                    return target;
                }
            }
        }
    }
    
    // Option 3 : Recherche par sélecteurs courants
    const possibleSelectors = [
        '[name="En 3 étapes"]',
        '.steps-section-v2',
        '.section-steps',
        '[class*="step"]',
        '[class*="feature"]',
        '.shopify-section'
    ];
    
    for (let selector of possibleSelectors) {
        target = document.querySelector(selector);
        if (target && target !== heroSection) {
            console.log('✅ Trouvé via sélecteur:', selector);
            return target;
        }
    }
    
    // Option 4 : Élément suivant le hero
    if (heroSection) {
        const heroParent = heroSection.closest('[id^="shopify-section-"]') || heroSection;
        target = heroParent.nextElementSibling;
        
        if (target && target.children.length > 0) {
            console.log('✅ Trouvé via nextElementSibling');
            return target;
        }
    }
    
    // Option 5 : Recherche exhaustive simplifiée
    const allSections = document.querySelectorAll('section, div[id*="section"], div[class*="section"]');
    for (let section of allSections) {
        const isNotHero = section !== heroSection && !section.contains(heroSection);
        // ✅ OPTIMISÉ : Vérifie juste l'existence d'enfants
        const hasContent = section.children.length > 0;
        const isAfterHero = heroSection ? section.compareDocumentPosition(heroSection) === Node.DOCUMENT_POSITION_PRECEDING : true;
        
        if (isNotHero && hasContent && isAfterHero) {
            target = section;
            console.log('✅ Trouvé via recherche exhaustive');
            return target;
        }
    }
    
    console.warn('⚠️ Aucune section trouvée, utilisation du fallback');
    return null;
}

// Fonction pour gérer le clic avec retry
function handleScrollClick(e) {
    if (e) e.preventDefault();
    
    let target = findTargetSection();
    
    if (!target) {
        console.log('⏳ Réessai dans 300ms...');
        setTimeout(() => {
            target = findTargetSection();
            if (target) {
                console.log('✅ Section trouvée après délai, scroll vers:', target);
                smoothScrollTo(target);
            } else {
                console.warn('⚠️ Section toujours introuvable, scroll par défaut');
                // ✅ OPTIMISÉ : Utilise 100vh au lieu de window.innerHeight
                window.scrollTo({
                    top: document.documentElement.clientHeight,
                    behavior: 'smooth'
                });
            }
        }, 300);
    } else {
        console.log('✅ Scroll immédiat vers:', target);
        smoothScrollTo(target);
    }
}

// Initialisation des event listeners
function initScrollButtons() {
    const scrollBtn = document.getElementById('scroll-btn');
    const scrollArrow = document.getElementById('scroll-arrow');
    
    if (scrollBtn) {
        scrollBtn.addEventListener('click', handleScrollClick);
        scrollBtn.addEventListener('touchend', function(e) {
            e.preventDefault();
            handleScrollClick(e);
        }, { passive: false });
        console.log('✅ Bouton LET\'S GO! initialisé (click + touch)');
    } else {
        console.warn('⚠️ Bouton scroll-btn non trouvé');
    }
    
    if (scrollArrow) {
        scrollArrow.addEventListener('click', handleScrollClick);
        scrollArrow.addEventListener('touchend', function(e) {
            e.preventDefault();
            handleScrollClick(e);
        }, { passive: false });
        console.log('✅ Flèche de scroll initialisée (click + touch)');
    } else {
        console.warn('⚠️ Flèche scroll-arrow non trouvée');
    }
}

// Attendre que le DOM soit complètement chargé
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initScrollButtons);
} else {
    initScrollButtons();
}

// Double sécurité
window.addEventListener('load', function() {
    console.log('🔄 Page complètement chargée, vérification des boutons...');
    const scrollBtn = document.getElementById('scroll-btn');
    if (scrollBtn && !scrollBtn.onclick) {
        console.log('🔧 Réinitialisation des event listeners');
        initScrollButtons();
    }
});

// ============================================================
// SYSTÈME DE PARTICULES OPTIMISÉ - DÉSACTIVÉ SUR MAC
// ============================================================
const canvas = document.getElementById('particlesCanvas');

// ✅ DÉTECTION MAC/SAFARI pour désactiver les particules
const isMac = /Mac|iPhone|iPad|iPod/.test(navigator.platform) || 
              /Macintosh/.test(navigator.userAgent);
const isSafariParticles = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

if (isMac || isSafariParticles) {
    // Sur Mac/Safari: masquer complètement les particules
    console.log('🍎 Mac/Safari détecté - Particules désactivées pour performance optimale');
    if (canvas) canvas.style.display = 'none';
} else {
    // Sur Windows/autres: animation normale
    console.log('💻 Windows/autre détecté - Particules activées');
    
    const ctx = canvas.getContext('2d');

    // ✅ OPTIMISÉ : Dimensions stockées une seule fois au chargement
    let canvasWidth = window.innerWidth;
    let canvasHeight = window.innerHeight;
    canvas.width = canvasWidth;
    canvas.height = canvasHeight;

    let particles = [];
    // ✅ OPTIMISÉ : Utilise matchMedia
    const isMobileDevice = window.matchMedia('(max-width: 768px)').matches;
    const particleCount = isMobileDevice ? 30 : 80;

    class Particle {
        constructor() { this.reset(); }
        
        reset() {
            this.x = Math.random() * canvasWidth;
            this.y = Math.random() * canvasHeight;
            this.size = Math.random() * 3 + 1;
            this.speedX = (Math.random() - 0.5) * 0.5;
            this.speedY = (Math.random() - 0.5) * 0.5;
            this.opacity = Math.random() * 0.5 + 0.2;
            this.color = ['rgba(135, 206, 250, ', 'rgba(255, 215, 0, ', 'rgba(255, 182, 193, ', 'rgba(255, 255, 255, '][Math.floor(Math.random() * 4)];
        }
        
        update() {
            this.x += this.speedX; 
            this.y += this.speedY;
            
            if (Math.random() < 0.01) {
                this.opacity += (Math.random() - 0.5) * 0.1;
                this.opacity = Math.max(0.1, Math.min(0.7, this.opacity));
            }
            
            if (this.x < 0 || this.x > canvasWidth || this.y < 0 || this.y > canvasHeight) this.reset();
        }
        
        draw() {
            ctx.fillStyle = this.color + this.opacity + ')';
            ctx.beginPath(); 
            ctx.arc(this.x, this.y, this.size, 0, Math.PI * 2); 
            ctx.fill();
            ctx.shadowBlur = 10; 
            ctx.shadowColor = this.color + this.opacity + ')';
        }
    }

    for (let i = 0; i < particleCount; i++) particles.push(new Particle());

    function animate() {
        ctx.clearRect(0, 0, canvasWidth, canvasHeight);
        
        if (!isMobileDevice) {
            particles.forEach(p => { p.update(); p.draw(); });
            
            particles.forEach((p1, i) => {
                particles.slice(i + 1).forEach(p2 => {
                    const d = Math.hypot(p1.x - p2.x, p1.y - p2.y);
                    if (d < 100) {
                        ctx.strokeStyle = `rgba(255, 255, 255, ${0.1 * (1 - d / 100)})`;
                        ctx.lineWidth = 1; 
                        ctx.beginPath(); 
                        ctx.moveTo(p1.x, p1.y); 
                        ctx.lineTo(p2.x, p2.y); 
                        ctx.stroke();
                    }
                });
            });
            
            requestAnimationFrame(animate);
        } else {
            // Sur mobile : particules statiques
            particles.forEach(p => { p.draw(); });
        }
    }

    animate();

    // ✅ OPTIMISÉ : Met à jour les dimensions stockées au resize
    window.addEventListener('resize', () => {
        canvasWidth = window.innerWidth;
        canvasHeight = window.innerHeight;
        canvas.width = canvasWidth; 
        canvas.height = canvasHeight;
    });

    // Interaction souris désactivée sur mobile
    if (!isMobileDevice) {
        canvas.addEventListener('mousemove', (e) => {
            if (Math.random() < 0.3) {
                const p = new Particle();
                p.x = e.clientX + (Math.random() - 0.5) * 50;
                p.y = e.clientY + (Math.random() - 0.5) * 50;
                p.size = Math.random() * 2 + 1;
                particles.push(p);
                if (particles.length > particleCount + 20) particles.shift();
            }
        });
    }
}